import { render, staticRenderFns } from "./LoginSB.vue?vue&type=template&id=1efd4c34&scoped=true&"
import script from "./LoginSB.vue?vue&type=script&lang=js&"
export * from "./LoginSB.vue?vue&type=script&lang=js&"
import style0 from "./LoginSB.vue?vue&type=style&index=0&id=1efd4c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd4c34",
  null
  
)

export default component.exports